import 'models/logistic'
import { LogisticCart, LogisticCartStatus } from 'models/logistic_cart'
import { PaginationParams, PaginationResponse } from 'models/pagination'

export enum LogisticCartReportType {
  DEFAULT = 'excel',
  BY_USERS = 'excel_by_users',
}

export interface GetLogisticCartsResponse
  extends PaginationResponse<{
    client_full_name: LogisticCart['client_full_name']
    created_at: LogisticCart['created_at']
    get_cart_type_display: string
    get_degree_urgency_display: string
    get_status_display: string
    id: LogisticCart['id']
    pan: LogisticCart['pan']
  }> {}

export interface GetLogisticCartsParams extends PaginationParams {
  start_date?: string
  end_date?: string
  status?: LogisticCartStatus
  pan?: string
  search?: string
}

export interface CreateLogisticCart {
  date_embossment: LogisticCart['date_embossment']
  client_full_name: LogisticCart['client_full_name']
  pan: LogisticCart['pan']
  phone: LogisticCart['phone']
  cart_type: LogisticCart['cart_type']
  degree_urgency?: LogisticCart['degree_urgency']
  status?: LogisticCart['status']
  comment?: LogisticCart['comment']
  specialist?: LogisticCart['specialist']
}

export interface UpdateLogisticCartStatus {
  id: LogisticCart['id']
  body: {
    status: LogisticCartStatus
    comment?: string
  }
}
